export const enum SnackbarType {
  SUCCESS = 'success',
  MESSAGE = 'message',
}

export const enum SnackbarLocation {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type Snackbar = {
  uuid: string
  message: string
  type: SnackbarType
  location: SnackbarLocation
  timeout: number
}
